// Vendors
import {
  HeaderOnboardingComponent,
  StyledComponentsProvider,
} from '@openbank/ziniaweb-ui-components';
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Components
import { HeaderLayoutModalComponent } from './components/modal/header-layout-modal.component';
// Constants
import {
  ENTRYPOINT_HEADER_COMPONENT_PROPS,
  HEADER_LAYOUT_STYLED_PROVIDER_THEME,
} from './constants/header-layout.constants';
// Hooks
import { useHeaderLayoutHook } from './hooks/header-layout.hook';
// Styles
import {
  HeaderLayoutContentComponentStyled,
  HeaderLayoutHeaderComponentStyled,
} from './header-layout.component.styled';
// Translations
import { BACK } from './translations/header-layout.translations';

const HeaderLayoutComponent = ({ children }: ReactChildrenType): React.ReactElement => {
  const {
    backModalConfiguration,
    disableBack,
    formatMessage,
    handleBackButtonClick,
    handleCloseDropModalActionClick: onClose,
    handleOnLinkCloseDropModal: onLinkClose,
    handleTrackOpenModal: onOpenModal,
    showDropModal,
  } = useHeaderLayoutHook();

  return (
    <main>
      <StyledComponentsProvider {...HEADER_LAYOUT_STYLED_PROVIDER_THEME}>
        <HeaderLayoutHeaderComponentStyled>
          <HeaderOnboardingComponent
            {...ENTRYPOINT_HEADER_COMPONENT_PROPS}
            button={{
              children: formatMessage({ id: BACK }),
              disabled: disableBack,
              onClick: handleBackButtonClick,
            }}
          />
        </HeaderLayoutHeaderComponentStyled>
      </StyledComponentsProvider>
      <HeaderLayoutContentComponentStyled>{children}</HeaderLayoutContentComponentStyled>
      <HeaderLayoutModalComponent
        {...{ onClose, onLinkClose, onOpenModal, showDropModal, backModalConfiguration }}
      />
    </main>
  );
};

export { HeaderLayoutComponent };
